import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { digitsThree } from "../../utils/price";
import moment from "jalali-moment";
import UpdateProductsStockLogsFilter from "./sub-components/update-product-stock-logs/UpdateProductsStockLogsFilter";
import { UpdateProductsStockLogsColumns } from "../../constant/tables-columns/tablesColums";
import { convertDate } from "../../utils/convertDate";

export default function UpdateProductsStockLogs() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [reportsData, setReportsData] = useState([]);

  const getProductReports = async (params) => {
    const path = "admin/products/inventoryLogs";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      console.log(response);
      setReportsData(response?.data?.result.data);
    });
  };

  useEffect(() => {
    filterDataHandler({
      // from: moment().locale("en").format("YYYY-MM-DD"),
      // to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  const data = [];

  reportsData?.map((item) =>
    data.push({
      ...item,
      name: item?.product?.name,
      varNumber: item?.productVarSku || "-",
      userName: item?.user?.name,
      difference: Number(item?.stock) - Number(item.preStock),
      createdAt: convertDate(item?.createdAt),
    })
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"لاگ آپدیت موجودی محصول"} />
      </div>
      <UpdateProductsStockLogsFilter filterDataHandler={filterDataHandler} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={UpdateProductsStockLogsColumns} rows={data} />
    </div>
  );
}
